<template>
  <div class="messages" v-if="proList && proList.length">
     <div class="title-top">
        <span></span>
        <h3>Product</h3>
    </div>
    <div class="section-info">
        <div class="pi">
            <div class="pi-wrap" v-for="(item, index) in proList" :key="'act-item-' + index">
                <div class="wrap" @click="linkToPro(item)">
                    <div class="photo">
                        <img :src="item.banner[0]" v-if="item.banner[0]">
                        <img src="@assets/img/empty.png" v-else>
                    </div>
                    <div class="title">
                        <h3 :title="item.nameEn" v-if="item.nameEn">{{item.nameEn}}</h3>
                        <h3 :title="item.name" v-else>{{item.name}}</h3>
                        <p style="padding-left: 12px;" class="title-line" v-if="item.category && item.category.Value">
                          <i class="icon iconfont icon-biaoqian1" style="color: #329bba;"></i>
                          <span
                          v-if="item.category.List && item.category.List.length > 0"
                          :title="item.category.Value + ' > ' + item.category.List[0].Value"
                          >{{item.category.Value + ' > ' + item.category.List[0].Value}}</span>
                          <span
                          v-else
                          :title="item.category.Value"
                          >{{item.category.Value}}</span>
                        </p>
                    </div>
                    <div v-if="item.tag && item.tag.Value">
                      <span
                      class="wrap-type"
                      v-if="item.tag.List && item.tag.List.length > 0"
                      >{{item.tag.Value + '/' + item.tag.List[0].Value}}</span>
                      <span
                      class="wrap-type"
                      v-else
                      >{{item.tag.Value}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div
          class="more m-load"
          v-if="donetTip"
        >
          <span class="load-finish">The end</span>
        </div>
        <div
          class="more m-load"
          v-if="!donetTip"
          @click="loadMore"
        >
          <span class="load-finish">More</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pro-list",
  props: ["msgData"], 
  data(){
    return{
      message:'',
      TotalPage: 1, // 页总数
      pageIndex: 1, // 当前页
      pageSize: 8, // 当前页
      msgTotal: 0, // 所有留言人数
      compId:"",
      proList:[],
      donetTip:false,
    }
  },
  computed:{
  },
  created(){
    this.getProData();
  },
  watch: {
    "$route"(to, from) {
      if (to) {
        this.TotalPage = 1;
        this.pageIndex = 1;
        this.pageSize = 8;
        this.proList = [];
        this.donetTip = true;
        this.getProData();
      }
    }
  },
  methods:{
    loadMore(){
        this.pageIndex += 1;
        this.getProData();
    },
    getProData(){
        this.compId = this.$router.history.current.query.compId;
        let body = {
            pageSize: this.pageSize,
            pageIndex: this.pageIndex,
            CompId: this.compId,
            Wheres: ""
        }
        let url = `/api/product/GetByCompany?topic=-1`;
        this.$service.getExAllPro(this,body,url);
    },
    linkToPro(item){
      const url = location.origin + "/pro-detailsEn/" + item.id + "?compId=" + item.compId;
      window.open(url,"_blank");
      // this.$router.push(`/pro-details/${item.id}?compId=${item.compId}`);
    }
  }
};
</script>

<style scoped lang='scss'>
.messages{
  box-shadow: 0px 1px 3px 0px 
		rgba(95, 99, 104, 0.1);
  .title-top{
    position: relative;
    padding-left: 20px;
    display: flex;
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #f5f5f5;
    span{
        display: inline-block;
        width: 4px;
        height: 16px;
        background-color: #d13119;
    }
    h3{
        display: inline-block;
        font-size: 16px;
        line-height: 18px;
        color: #333;
        margin-left: 15px;
    }
  }
}
.more {
  height: 80px;
  text-align: center;
}
.more span {
  color: #040000;
  font-size: 14px;
  cursor: pointer;
  line-height: 80px;
}
</style>
<style scoped lang="scss">
@import "@assets/scss/utils.scss";
.section-info{
    padding:20px;
}
.pi {
  overflow: hidden;
  &-wrap {
    cursor: pointer;
    display: block;
    width: 194px;
    margin:0 20px 20px 0;
    float: left;
    overflow: hidden;
    color: #ccc;
    border:1px solid  #f5f5f5;
    &:nth-of-type(4n) {
      margin-right: 0px;
    }
  }
}
.wrap {
  width: 100%;
  height: 215px;
  border-radius: 3px;
  background-color: #fff;
  position: relative;
  float: left;
  cursor: pointer;
    .wrap-type{
      position: absolute;
      left:14px;
      top: 123px;
      z-index: 10;
      display: inline-block;
      color: #fff;
      font-size: 14px;
      padding:2px 6px;
      border-radius: 2px;
      background-color: #d13119;
    }
}
.wrap .photo {
  height: 135px;
  overflow: hidden;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.wrap .title {
  height: 85px;
}
.wrap .title h3 {
  font-size: 14px;
  padding: 0 14px;
  color: #333;
  line-height: 18px;
  padding-top: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wrap .title {
  span {
    font-size: 14px;
    color: #999;
    line-height: 32px;
    padding-left: 4px;
  }
  .title-line {
    display: flex;
    align-items: center;
    .icon{
        font-size: 22px;
    }
    span {
      width: calc(100% - 1px);
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #999;
    }
  }
}
</style>